<template>
  <el-row>
    <el-col>
      <el-card shadow="never">
        <TeamProfilesTable
          ref="profilesTable"
          :account-id="$route.params.accountId"
          :team-id="$route.params.teamId"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import TeamProfilesTable from '@/components/Application/Manage/Account/TeamProfilesTable'

export default {
  components: {
    TeamProfilesTable
  },
  data () {
    return {
      actions: [],
      breadcrumb: {
        name: 'Attached Users',
        route: { name: 'manage-accounts-account-configurations-teams-team-profiles', params: { accountId: this.$route.params.accountId, teamId: this.$route.params.teamId } }
      }
    }
  },
  mounted () {
    this.actions = this.$refs.profilesTable.actions
  }
}
</script>
